class EtobaMegaMenu extends HTMLElement {
  constructor() {
    super();
    this.openTimers = new Map();
    this.closeTimers = new Map();
    this.activeItem = null;
    this.HOVER_OPEN_DELAY = 80;
    this.HOVER_CLOSE_DELAY = 200;
  }

  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('[data-mega-item]'));
    this.backdrop = this.querySelector('[data-mega-backdrop]');

    this.items.forEach((item) => this.bindItem(item));
    document.addEventListener('keydown', this.onKeyDown);
    document.addEventListener('click', this.onDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKeyDown);
    document.removeEventListener('click', this.onDocumentClick);
  }

  bindItem(item) {
    const trigger = item.querySelector('[data-mega-trigger]');
    const panel = item.querySelector('[data-mega-panel]');
    if (!trigger || !panel) return;

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const isOpen = item.dataset.open === 'true';
      this.closeAll();
      if (!isOpen) this.open(item);
    });

    item.addEventListener('mouseenter', () => {
      if (window.matchMedia('(hover: none)').matches) return;
      clearTimeout(this.closeTimers.get(item));
      const timer = setTimeout(() => {
        this.closeAll(item);
        this.open(item);
      }, this.HOVER_OPEN_DELAY);
      this.openTimers.set(item, timer);
    });

    item.addEventListener('mouseleave', () => {
      if (window.matchMedia('(hover: none)').matches) return;
      clearTimeout(this.openTimers.get(item));
      const timer = setTimeout(() => {
        this.close(item);
      }, this.HOVER_CLOSE_DELAY);
      this.closeTimers.set(item, timer);
    });
  }

  open(item) {
    if (!item) return;
    const trigger = item.querySelector('[data-mega-trigger]');
    const panel = item.querySelector('[data-mega-panel]');
    if (!panel) return;

    item.dataset.open = 'true';
    trigger?.setAttribute('aria-expanded', 'true');
    panel.removeAttribute('hidden');

    requestAnimationFrame(() => {
      panel.dataset.state = 'open';
    });

    if (this.backdrop) this.backdrop.dataset.state = 'open';
    this.activeItem = item;
    this.dispatchEvent(new CustomEvent('mega-menu:open', { detail: { item } }));
  }

  close(item) {
    if (!item) return;
    const trigger = item.querySelector('[data-mega-trigger]');
    const panel = item.querySelector('[data-mega-panel]');
    if (!panel) return;

    item.dataset.open = 'false';
    trigger?.setAttribute('aria-expanded', 'false');
    panel.dataset.state = 'closing';

    setTimeout(() => {
      if (panel.dataset.state === 'closing') {
        panel.setAttribute('hidden', '');
        panel.dataset.state = '';
      }
    }, 240);

    if (this.activeItem === item) this.activeItem = null;
    if (this.backdrop && !this.activeItem) this.backdrop.dataset.state = '';
  }

  closeAll(except = null) {
    this.items.forEach((item) => {
      if (item !== except && item.dataset.open === 'true') this.close(item);
    });
  }

  onKeyDown = (e) => {
    if (e.key === 'Escape' && this.activeItem) {
      const trigger = this.activeItem.querySelector('[data-mega-trigger]');
      this.close(this.activeItem);
      trigger?.focus();
    }
  };

  onDocumentClick = (e) => {
    if (!this.contains(e.target)) {
      this.closeAll();
    }
  };
}

if (!customElements.get('etoba-mega-menu')) {
  customElements.define('etoba-mega-menu', EtobaMegaMenu);
}
